import { render, staticRenderFns } from "./rule-popup.vue?vue&type=template&id=05430043&scoped=true"
import script from "./rule-popup.vue?vue&type=script&lang=js"
export * from "./rule-popup.vue?vue&type=script&lang=js"
import style0 from "./rule-popup.vue?vue&type=style&index=0&id=05430043&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05430043",
  null
  
)

export default component.exports